import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { Logout } from "./LoginActions";
import { PostAlert } from "./AlertActions";
import { getUser } from "../state/userSlice";
import { getUserList, updateUserList } from "../state/userListSlice";
export function GetUserList(dispatch) {
  axios.get(`${Globals.baseUrl}/Users/GetAllUsers`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.UsersGetUsers,
        Result: res.data
      });
      if (dispatch !== void 0) {
        dispatch(getUserList(res.data));
      }
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetUser(userId, dispatch) {
  axios.get(`${Globals.baseUrl}/Users/GetUser/${userId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatch(getUser(res.data));
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((res) => {
    dispatch(getUser(res.data));
  });
}
export function GetUserFromDb(userId, callBack) {
  console.log("GetUserFromDB");
  axios.get(`${Globals.baseUrl}/Users/GetUser/${userId}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      callBack(res.data);
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((res) => {
  });
}
export function ChangePassword(userId, password, dispatch) {
  axios.post(
    `${Globals.baseUrl}/Users/ChangePassword`,
    { Password: password, UserId: userId },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      PostAlert("success", "Password changed");
    } else if (res.status === 400 || res.status === 401) {
      Logout(dispatch);
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function SaveUser(userId, userInfo, dispatch, callback) {
  axios.post(
    `${Globals.baseUrl}/Users/UpdateUser`,
    { UserId: userId, UserInfo: userInfo },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      if (res.data === "Success" || res.data.startsWith("User Created")) {
        PostAlert("success", "User data updated");
        if (res.data.startsWith("User Created")) {
          let idx = res.data.indexOf(":");
          let uid = res.data.substring(idx + 1);
          userInfo.userId = uid;
        }
        dispatch(updateUserList(userInfo));
        callback(res.data);
      }
      if (res.data.startsWith("Error")) {
        PostAlert("error", "Unable to update user data");
        PostAlert("error", res.data);
        callback(res.data);
      }
    } else if (res.status === 400 || res.status === 401) {
      Logout(dispatch);
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function UpdateSetting(setting, value) {
  axios.post(
    `${Globals.baseUrl}/Users/UpdateSetting`,
    { settingName: setting, settingValue: value },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.UserChangeSetting,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      Logout();
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
